import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { DesktopBootstrap } from "./environment/DesktopBootstrap";
import type { BootstrapPolicy } from "./environment/environment";
import "./styles.css";

// Build-pinned policy: never inferred from a failed manifest or runtime URL.
declare const __PW_BOOTSTRAP_POLICY__: BootstrapPolicy;

createRoot(document.getElementById("root")!).render(
  <StrictMode><DesktopBootstrap policy={__PW_BOOTSTRAP_POLICY__} /></StrictMode>,
);
